import React, { useEffect, useState } from "react";
import Chart from 'react-apexcharts'
import axios from "axios";
import moment from "moment";
import { Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Link, useNavigate, useLocation } from "react-router-dom";
const ActivityGraph = () => {
  const [TotalRequestDates, setTotalRequestDates] = useState([])
  const [pieChatNames, setpieChatNames] = useState([])
  const [totalinput, settotalinput] = useState([])
  const [totaloutput, settotaloutput] = useState([])
  const [listofchartboats, setlistofchartboats] = useState([])
  const [pieChatdata, setpieChatData] = useState([])
  const [selectAgenet, setselectAgenet] = useState()
  const [data, setData] = useState([])
  const currentDateTime = moment(); // Current date and time
  const startOfMonth = moment().startOf('month').format('YYYY-MM-DD'); // First day of the current month
  const formattedDate2 = currentDateTime.format('YYYY-MM-DD'); // Current date
  const navigate = useNavigate()
  const location = useLocation();

  const [start_date, setstart_date] = useState(startOfMonth);
  const [formattedDate, setformattedDate] = useState(formattedDate2);
  useEffect(() => {
    getChatGraphData()
  }, [start_date, formattedDate])
  const optionscolumnchart = {
    chart: {
        type: 'bar',
        height: 500,
        stacked: true,
        toolbar: {
            show: true
        },
        zoom: {
            enabled: false
        }
    },
    colors: ["#3366d6", "#4285f4", "#71a3f7", "#a0c2fa", "#d0e0fc"],
    responsive: [{
        breakpoint: 480,
        options: {
            legend: {
                show: false
            }
        }
    }],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: 'end',
            borderRadiusWhenStacked: 'last'
        },
    },
    tooltip: {
        shared: true,
        intersect: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let tooltipHTML = `<div style="padding: 8px; font-size: 13px;">`;
            
            // Get the category (X-axis label)
            let category = w.globals.labels[dataPointIndex];
            tooltipHTML += `<strong>${category}</strong><br>`;

            // Iterate over all series and add values
            let total = 0;
            series.forEach((s, index) => {
                let value = s[dataPointIndex] || 0;
                total += value;
                let seriesName = w.globals.seriesNames[index]; // Get series name
                
                tooltipHTML += `
                    <span style="color: ${w.globals.colors[index]}; font-weight: bold;">●</span> 
                    ${seriesName}: <strong>${value}</strong><br>`;
            });

            // Add total separately at the bottom
            tooltipHTML += `<hr style="margin: 5px 0; border-color: #ddd;">
                            <strong>Total: ${total}</strong>`;
            
            tooltipHTML += `</div>`;
            return tooltipHTML;
        }
    },
    xaxis: {
        type: 'date',
        categories: TotalRequestDates,
        tickAmount: 5,
        labels: {
            formatter: function (value) {
                return moment(value).format("DD MMM");
            }
        }
    },
    legend: {
        display: false,
    },
    states: {
        hover: {
            filter: {
                type: 'none'
            }
        }
    },
};


  const options3 = {
    chart: {
      width: 380,
      type: 'pie',
    },
    stroke: {
      show: false // This removes the slice border
    },
    colors: ["#3366d6", "#4285f4", "#71a3f7", "#a0c2fa", "#d0e0fc"],
    labels: pieChatNames,
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 400
        },
        legend: {
          display: false,
        }
      }
    }]
  }


  const series4 = [
    {
      name: 'Input',
      data: totalinput
    },
    {
      name: 'Output',
      data: totaloutput
    }
  ]
  const GetChartboatsList = () => {
    axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
    axios.get('apiV1/chatbot/').then((rep) => {
      if(rep.data.length !==0){
        getChatGraphDatabyID(rep.data[0].id)
        setlistofchartboats(rep.data)
        setselectAgenet(rep.data[0].id)
      }
      
    }).catch((e) => {

    })
  }
  useEffect(() => {
    GetChartboatsList()
    getChatGraphData();
    getChatGraphData2();
  }, [])

  function convertChatbotData(inputData) {
    const output = [];
    const chatbotData = {};
    // Extract chatbot names and total tokens used for each day
    Object.entries(inputData).forEach(([date, chatbots]) => {
      chatbots.forEach(chatbot => {
        if (!chatbotData[chatbot.chatbot_name]) {
          chatbotData[chatbot.chatbot_name] = [];
        }
        chatbotData[chatbot.chatbot_name].push(chatbot.total_requests);
      });
    });
    // Generate the output structure based on chatbot names
    Object.entries(chatbotData).forEach(([name, data]) => {
      output.push({ name, data });
    });

    return output;
  }
  const getChatGraphData = () => {
    axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
    axios.get(`apiV1/requests-bar-graph/?start_date=${start_date}&end_date=${formattedDate}`).then((rep) => {
      let array = []
      for (const property in rep.data) {
        array.push(property)
      }
      const completedata = convertChatbotData(rep.data);
      console.log(completedata)
      setData([...completedata])
      setTotalRequestDates([...array])
    }).catch((e) => {

    })
  }

  const getChatGraphDatabyID = (id) => {
    axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
    axios.get(`apiV1/requests-bar-graph/?start_date=${start_date}&end_date=${formattedDate}&chatbot_id=${id}`).then((rep) => {
      let array = []
      let inputs = []
      let outputs = []
      for (const property in rep.data) {
        array.push(property)
        rep.data[property].map((item, i) => {
          inputs.push(item.total_input_tokens)
          outputs.push(item.total_output_tokens);
          return item
        })
      }
      settotalinput([...inputs])
      settotaloutput([...outputs])
      setTotalRequestDates([...array])
      console.log(array)
      //setlistofchartboats(rep.data)
    }).catch((e) => {

    })
  }


  const getChatGraphData2 = () => {
    let names = []
    let percent = []
    axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
    axios.get(`apiV1/monthly-pie-chart/?start_date=${start_date}&end_date=${formattedDate}`).then((rep) => {
      rep.data.data.map((item, i) => {
        names.push(item.chatbot_name)
        percent.push(item.percentage);
        return item
      })
      setpieChatNames([...names])
      setpieChatData([...percent])

    }).catch((e) => {

    })
  }

  const isDashboard = location.pathname === "/dashboard";

  const handleChange = (_, newPath) => {
    if (newPath !== null) navigate(newPath);
  };
  return (
    <div className="  pt-5">
      <div className="row">
        <div className="col-md-12 mb-3">
          <div className="row">
            <div className="col-md-12 d-flex gap-2">
              

            </div>
            {/* <h4>Activity Dashboard</h4> */}
            <div className="col-md-8">
            <ToggleButtonGroup
                value={location.pathname}
                exclusive
                onChange={handleChange}
                sx={{
                  "& .MuiToggleButton-root": {
                    color: "#3a86fe",
                  },
                  "& .MuiToggleButton-root.Mui-selected": {
                    backgroundColor: "#3367d7 !important", 
                    color: "white !important",
                    fontWeight: "bold", 
                  },
                  "& .MuiToggleButton-root:not(.Mui-selected):hover": {
                    backgroundColor: "transparent",
                    color: "#3a86fe",
                  },
                }}
              >
                <ToggleButton value="/dashboard">Activity Dashboard</ToggleButton>
                <ToggleButton value="/costdashboard">Cost Dashboard</ToggleButton>
              </ToggleButtonGroup>

            </div>
            {/* <h4>Activity Dashboard</h4> */}
            <div className="col-md-8">
                
            </div>
            <div className="col-md-2">
              <label>Start Date</label>
              <input type="date" className="form-control" value={start_date} onChange={(e) => setstart_date(e.target.value)} />
            </div>
            <div className="col-md-2">
              <label>End Date</label>
              <input type="date" className="form-control" value={formattedDate} onChange={(e) => setformattedDate(e.target.value)} />
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-md-9">
            <div className="card" style={{ height: "100%" }}>
              <div className="card-body">
                <Chart options={optionscolumnchart} series={data} type="bar" height={400} />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card h-100 d-flex flex-column justify-content-between">
              <div className="card-body d-flex flex-column align-items-center">
                <Chart
                  options={{
                    ...options3,
                    legend: {
                      position: "bottom",
                      horizontalAlign: "center",
                    },
                  }}
                  series={pieChatdata}
                  type="pie"
                  height={400}
                  width={400}
                />
              </div>
            </div>
          </div>

        </div>

        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row mt-2 mb-2">
                <div className="col-md-9">

                </div>
                <div className="col-md-3">
                  <label>Select Agent</label>
                  <select class="form-select" id="inlineFormSelectPref" value={selectAgenet} onChange={(e) => { getChatGraphDatabyID(e.target.value); setselectAgenet(e.target.value) }}>
                    <option  >Choose...</option>
                    {listofchartboats.map((item, i) => {
                      return (
                        <option value={item.id}>{item.name}</option>
                      )
                    })}


                  </select>

                </div>
              </div>
              <Chart options={optionscolumnchart} series={series4} type="bar" height={400} />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default ActivityGraph;